export enum ProspectActionEnum {
  Emailed = 1,
  Called = 2,
  SMS = 3,
  PushNotification = 4,
  Other = 5,
  Bid = 6
}
